// extracted by mini-css-extract-plugin
module.exports = {"chart":"HorizontalBarChart_chart__3wlhE","outlined":"HorizontalBarChart_outlined__2dRaR","header":"HorizontalBarChart_header__3Z2Yy","title":"HorizontalBarChart_title__2TKPt"};